const formValidators = {
  checkNumber: function(rule, value, callback) {
    if (value && !/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value)) {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  },
  checkInteger: function(rule, value, callback) {
    if (value && !/^-?\d+$/.test(value)) {
      callback(new Error('请输入整数'))
    } else {
      callback()
    }
  },
  checkMobile: function(rule, value, callback) {
    if (value && !(value.length === 11 && /^(1[3|4|5|6|7|8|9][0-9]\d{8})$/.test(value))) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  },
  checkEmail: function(rule, value, callback) {
    if (value && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value)) {
      callback(new Error('请输入正确的邮箱地址'))
    } else {
      callback()
    }
  },
  checkSpace: function(rule, value, callback) {
    if (value && !/^\S+$/.test(value)) {
      callback(new Error('不能带有空格'))
    } else {
      callback()
    }
  },
  checkPasswordSolid: function(rule, value, callback) {
    // let reg = /^(?!([a-zA-Z\d]*|[\d!@#\$%_\.]*|[a-zA-Z!@#\$%_\.]*)$)[a-zA-Z\d!@#\$%_\.]{8,20}$/;
    // const reg = /^(?![0-9a-z]+$)(?![0-9A-Z]+$)(?![0-9\W]+$)(?![a-z\W]+$)(?![a-zA-Z]+$)(?![A-Z\W]+$)[a-zA-Z0-9\W_]+$/
    const reg = /^(?=.*\d)(?=.*[a-zA-Z])[^*]{8,}$/
    if (!reg.test(value)) {
      callback(new Error('密码要包含字母、数字且不少于8位'))
    } else {
      callback()
    }
  },
  validateAreaData: function(rule, value, callback) {
    if (!value.provinceId) {
      callback(new Error('请选择省份'))
    } else if (!value.cityId) {
      callback(new Error('请选择城市'))
    } else if (!value.countyId) {
      callback(new Error('请选择区县'))
    } else {
      callback()
    }
  }
}

export default formValidators
